import React, { useEffect, useRef, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Volume2 } from "lucide-react";

export default function CrewVoicePlayback({ requestId, available }) {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const source = useRef("");
  const alive = useRef(false);
  const active = useRef(null);
  useEffect(() => {
    alive.current = true;
    return () => { alive.current = false; active.current?.abort(); if (source.current) URL.revokeObjectURL(source.current); };
  }, [requestId]);
  if (!available) return null;
  const listen = async () => {
    if (active.current) return;
    const controller = new AbortController(); active.current = controller; setBusy(true); setError("");
    try {
      const { data } = await api.get(`/admin/voice/recordings/${requestId}`, { responseType: "blob", signal: controller.signal });
      if (!alive.current || controller.signal.aborted) return;
      source.current = URL.createObjectURL(data); setUrl(source.current);
    } catch (err) {
      if (!alive.current || controller.signal.aborted) return;
      let detail;
      try { detail = JSON.parse(await err.response?.data?.text()).detail; } catch {}
      setError(formatErr(detail) || "Recording expired or unavailable. Sent recordings are kept for 24 hours.");
    } finally { if (active.current === controller) active.current = null; if (alive.current) setBusy(false); }
  };
  return <div className="mt-3" data-testid="crew-voice-playback">
    {url ? <audio controls preload="none" src={url} className="w-full" aria-label="Original guest voice recording" /> :
      <Button variant="outline" size="sm" disabled={busy} onClick={listen}><Volume2 className="h-4 w-4 mr-2" />{busy ? "Loading recording…" : "Listen to original recording"}</Button>}
    <p className="text-xs text-muted-foreground mt-1">Original audio · available for 24 hours after sending</p>
    {error && <p role="alert" className="text-xs mt-1">{error}</p>}
  </div>;
}
